import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import LoadingArea from '@molecules/LoadingArea';
import PropertyCardBase from '@molecules/PropertyCard';
import PropertyListItemBase from '@molecules/PropertyListItem';

// Functionality
import useSavedProperties from '../../../hooks/useSavedProperties';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import { SAVED_PROPERTIES_QUERY } from '@general/graphql/properties.graph';
import { mapSearchPropertyToProps } from '@general/transforms/property.transform';

const PropertyCard = props => <PropertyCardBase openInNewTab {...props} />;
const PropertyListItem = props => <PropertyListItemBase openInNewTab {...props} />;

const SearchPropertiesSaved = ({
    additionalFilters,
    hitsPerPage,
    parentView,
    refinementComponent,
    resultsPerRow = 3,
    showFilters = false,
    showPagingToolbar = false,
    showSearchBox = false,
    showSearchOptions = false,
    updateSearchStateUrl = false,
    NoResultsText,
}) => {
    const [filters, setFilters] = useState();

    useSavedProperties({
        onCompleted: ({ savedProperties }) => {
            if (savedProperties.length === 0) {
                setFilters('objectID:NOT-A-PROPERTY');
                return;
            }

            let filterString = `(${savedProperties.map(p => `objectID:"${p.id}"`).join(' OR ')})`;
            filterString += ' AND manager.status:Active';
            setFilters(filterString);
        },
    });

    if (!filters) {
        return <LoadingArea />;
    }

    return (
        <SearchModeContext.Provider value={{ showFilters }}>
            <Search
                filters={filters + (additionalFilters ? ` AND ${additionalFilters}` : '')}
                hitsPerPage={hitsPerPage}
                index="properties"
                displayPagingToolbar={showPagingToolbar}
                displaySearchBox={showSearchBox}
                displaySearchOptions={showSearchOptions}
                refinementComponent={refinementComponent}
                updateSearchStateUrl={updateSearchStateUrl}
            >
                <SearchResults
                    cardComponent={PropertyCard}
                    index="properties"
                    listItemComponent={PropertyListItem}
                    parentView={parentView}
                    parentSubview="Saved Properties"
                    query={SAVED_PROPERTIES_QUERY}
                    transformFunc={mapSearchPropertyToProps}
                    typePlural="savedProperties"
                    resultsPerRow={resultsPerRow}
                    NoResultsText={NoResultsText}
                />
            </Search>
        </SearchModeContext.Provider>
    );
};

SearchPropertiesSaved.propTypes = {
    additionalFilters: PropTypes.string,
    hitsPerPage: PropTypes.number,
    parentView: PropTypes.string,
    refinementComponent: PropTypes.elementType,
    resultsPerRow: PropTypes.number,
    showFilters: PropTypes.bool,
    showPagingToolbar: PropTypes.bool,
    showSearchBox: PropTypes.bool,
    showSearchOptions: PropTypes.bool,
    updateSearchStateUrl: PropTypes.bool,
    NoResultsText: PropTypes.elementType,
};

export default SearchPropertiesSaved;
